import ui from "./ui";
import auth from "./auth";
const reducer = {
  ui,
  auth,
};

export default reducer;
